// extracted by mini-css-extract-plugin
export var defaultWidth = "Slider-module--defaultWidth--c9f51";
export var mediumWidth = "Slider-module--mediumWidth--91542";
export var smallWidth = "Slider-module--smallWidth--ee41d";
export var hidden = "Slider-module--hidden--99fbb";